import { render } from "./publicBenefit.vue?vue&type=template&id=673766ba&scoped=true"
import script from "./publicBenefit.vue?vue&type=script&lang=js"
export * from "./publicBenefit.vue?vue&type=script&lang=js"

import "./publicBenefit.vue?vue&type=style&index=0&id=673766ba&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673766ba"]])

export default __exports__